export const TECH_ASSETS_MODULE_NAME = "techAssets";
